import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';
import { action } from 'satcheljs/lib/legacy';
import { lazyLoadYammerThread } from 'owa-yammer-deeplink';

export interface YammerRouteParamaters {
    threadId?: string;
}

export let deepLinkYammerRouteHandler = action('deepLinkYammerRouteHandler')(
    async function deepLinkYammerRouteHandler(parameters: YammerRouteParamaters) {
        const { threadId } = parameters;
        if (threadId) {
            const loadYammerThread = await lazyLoadYammerThread.import();
            loadYammerThread(threadId);
        }

        setPopoutChildState(PopoutChildState.Ready);
    }
);
